import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

class TemplatesManager {

  constructor(application) {

    this.loaded = false;
    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  tryAdd(item) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', item._id);

    if (itemIndex !== -1) {
      this.collection.splice(itemIndex, 1);
    }

    this.collection.push({
      ...item,
      label: item.name,
      description: '',
      type: 'template'
    });

  }

  tryRemove(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    if (itemIndex === -1) {
      return;
    }

    this.collection.splice(itemIndex, 1);

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.template);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.template._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.TEMPLATE_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.TEMPLATE_DELETED, this.handleDeletedEvent.bind(this));

  }

  async loadAll() {

    if (this.loaded === true) {
      return;
    }
    this.collection = await serverInterface.startup.templates.getTemplates();

    // Editor filters looks in label field
    for (let object of this.collection) {

      object.label = object.name;
      object.description = '';
      object.type = 'template';

    }

    this.loaded = true;

  }

  getAll() {

    return this.collection;

  }

  isExistsById(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    return itemIndex !== -1;

  }

  async initialize() {

    this.registerEventHandlers();

    this.initialized = true;

  }

}

export default TemplatesManager;